// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryItem_item__ViKob {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  padding: 12px 0 0 12px;
  color: var(--text-color);
  overflow: hidden;
  position: relative;
  background: #DFD587;
  transition: var(--transition);
  transition-property: box-shadow;
}
@media (hover: hover) {
  .CategoryItem_item__ViKob:hover {
    box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);
  }
}
@media (min-width: 640px) {
  .CategoryItem_item__ViKob {
    padding: 24px 0 0 24px;
  }
}
@media (min-width: 1200px) {
  .CategoryItem_item__ViKob {
    color: var(--text-color);
    padding: 12px 0 0 12px;
  }
}

.CategoryItem_img__xlaXO {
  flex-shrink: 0;
  max-width: 100px;
  max-height: 70px;
  margin-left: auto;
  margin-top: auto;
}

.CategoryItem_title__6e9Rr {
  font-size: 15px;
  line-height: 16px;
  text-overflow: ellipsis;
  position: relative;
  padding-right: 12px;
  margin-bottom: 4px;
}
@media (min-width: 640px) {
  .CategoryItem_title__6e9Rr {
    font-size: 24px;
    line-height: 25px;
    padding-bottom: 2px;
    padding-right: 16px;
  }
}
@media (min-width: 1200px) {
  .CategoryItem_title__6e9Rr {
    font-size: 14px;
    line-height: 1;
    padding: 0 12px 0 0;
  }
}

.CategoryItem_wrap__6GMCp {
  display: flex;
  align-items: flex-start;
  flex: 1 1;
}

.CategoryItem_txtWrap__l6xaX {
  padding-right: 12px;
  padding-bottom: 12px;
}
@media (min-width: 640px) {
  .CategoryItem_txtWrap__l6xaX {
    padding-right: 16px;
    padding-bottom: 24px;
  }
}
@media (min-width: 1200px) {
  .CategoryItem_txtWrap__l6xaX {
    padding-right: 12px;
    padding-bottom: 12px;
  }
}

.CategoryItem_txt__a022L {
  font-size: 13px;
  line-height: 15px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  position: relative;
}
@media (min-width: 640px) {
  .CategoryItem_txt__a022L {
    font-size: 18px;
    line-height: 110%;
  }
}
@media (min-width: 1200px) {
  .CategoryItem_txt__a022L {
    font-size: 12px;
    line-height: 12px;
    color: #7A808B;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CategoryItem/CategoryItem.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;AACF;AACE;EACE;IACE,8CAAA;EACJ;AACF;AAEE;EAnBF;IAoBI,sBAAA;EACF;AACF;AACE;EAvBF;IAwBI,wBAAA;IACA,sBAAA;EAEF;AACF;;AACA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAEF;AAAE;EARF;IASI,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;EAGF;AACF;AADE;EAfF;IAgBI,eAAA;IACA,cAAA;IACA,mBAAA;EAIF;AACF;;AADA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAIF;;AADA;EACE,mBAAA;EACA,oBAAA;AAIF;AAFE;EAJF;IAKI,mBAAA;IACA,oBAAA;EAKF;AACF;AAHE;EATF;IAUI,mBAAA;IACA,oBAAA;EAMF;AACF;;AAHA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AAMF;AAJE;EAVF;IAWI,eAAA;IACA,iBAAA;EAOF;AACF;AALE;EAfF;IAgBI,eAAA;IACA,iBAAA;IACA,cAAA;EAQF;AACF","sourcesContent":[".item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  border-radius: 12px;\r\n  padding: 12px 0 0 12px;\r\n  color: var(--text-color);\r\n  overflow: hidden;\r\n  position: relative;\r\n  background: #DFD587;\r\n  transition: var(--transition);\r\n  transition-property: box-shadow;\r\n\r\n  @media (hover: hover) {\r\n    &:hover {\r\n      box-shadow: 0px 5px 9px 0px rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n\r\n  @media (min-width: 640px) {\r\n    padding: 24px 0 0 24px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    color: var(--text-color);\r\n    padding: 12px 0 0 12px;\r\n  }\r\n}\r\n\r\n.img {\r\n  flex-shrink: 0;\r\n  max-width: 100px;\r\n  max-height: 70px;\r\n  margin-left: auto;\r\n  margin-top: auto;\r\n}\r\n\r\n.title {\r\n  font-size: 15px;\r\n  line-height: 16px;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  padding-right: 12px;\r\n  margin-bottom: 4px;\r\n\r\n  @media (min-width: 640px) {\r\n    font-size: 24px;\r\n    line-height: 25px;\r\n    padding-bottom: 2px;\r\n    padding-right: 16px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: 14px;\r\n    line-height: 1;\r\n    padding: 0 12px 0 0;\r\n  }\r\n}\r\n\r\n.wrap {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  flex: 1;\r\n}\r\n\r\n.txtWrap {\r\n  padding-right: 12px;\r\n  padding-bottom: 12px;\r\n\r\n  @media (min-width: 640px) {\r\n    padding-right: 16px;\r\n    padding-bottom: 24px;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    padding-right: 12px;\r\n    padding-bottom: 12px;\r\n  }\r\n}\r\n\r\n.txt {\r\n  font-size: 13px;\r\n  line-height: 15px;\r\n  font-weight: 400;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 3;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  position: relative;\r\n\r\n  @media (min-width: 640px) {\r\n    font-size: 18px;\r\n    line-height: 110%;\r\n  }\r\n\r\n  @media (min-width: 1200px) {\r\n    font-size: 12px;\r\n    line-height: 12px;\r\n    color: #7A808B;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `CategoryItem_item__ViKob`,
	"img": `CategoryItem_img__xlaXO`,
	"title": `CategoryItem_title__6e9Rr`,
	"wrap": `CategoryItem_wrap__6GMCp`,
	"txtWrap": `CategoryItem_txtWrap__l6xaX`,
	"txt": `CategoryItem_txt__a022L`
};
export default ___CSS_LOADER_EXPORT___;
